module.exports = __webpack_public_path__ + "img/mb-step-1.f30e928d.png";